import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M8.4628 19.779L7.0498 18.364L11.9998 13.415L16.9438 18.37L15.5358 19.778L11.9998 16.242L8.4638 19.779H8.4628ZM11.9998 10.586L7.0548 5.63098L8.4638 4.22198L11.9998 7.75698L15.5348 4.22198L16.9498 5.63598L12.0008 10.585L11.9998 10.586Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "UnfoldLess"
);
